import React from 'react';
import { PapiDeviation, PapiUser } from '@wix/da-types-papi';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import { getInfoToDisplayImageDeviation } from '@wix/da-shared-react/pkg/DeviationViews/Dumbo/Image/_helpers';
import Slider, { SeeAllSlide } from '@wix/da-shared-react/pkg/Slider';
import { getIsTextType } from '@wix/da-shared-react/pkg/DeviationViews/_helpers';
import DuperbrowseContext from '../../../contexts/DuperbrowseContext';

import s from './StripExhibitionist.scss';

const EXHIBITIONIST_THUMB_HEIGHT = 240;

export interface Props {
  streamId: string;
  moduleId: number;
  deviations: PapiDeviation[];
  seeAllUrl?: string;
  hasMore?: boolean;
  profileOwnerUser: PapiUser;
}

function getThumbWidth(deviation: PapiDeviation) {
  // text stuff is square
  if (getIsTextType(deviation)) {
    return EXHIBITIONIST_THUMB_HEIGHT;
  }

  const info = getInfoToDisplayImageDeviation({
    deviation,
    height: EXHIBITIONIST_THUMB_HEIGHT,
  });
  return info?.width;
}

class StripExhibitionist extends React.Component<Props> {
  render() {
    return (
      <Slider className={s['slider']} scrollBy={0.5}>
        {this.renderSlides()}
      </Slider>
    );
  }

  renderSlides() {
    const {
      seeAllUrl,
      hasMore,
      deviations,
      profileOwnerUser,
      streamId,
    } = this.props;

    return (
      <DuperbrowseContext
        streamId={streamId}
        deviations={deviations}
        parent={{ title: profileOwnerUser.username }}
      >
        {deviations.map(deviation => (
          <StandardThumb
            key={deviation.deviationId}
            className={s['slider-item']}
            deviation={deviation}
            height={EXHIBITIONIST_THUMB_HEIGHT}
            width={getThumbWidth(deviation)}
            responsive={false}
          />
        ))}
        {hasMore && seeAllUrl && <SeeAllSlide seeAllUrl={seeAllUrl} />}
      </DuperbrowseContext>
    );
  }
}

export default StripExhibitionist;
